import { tw } from "@careinfo/tailwind";
import { Menu, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";

import { classNames } from "../../utils/classNames";
import { toast } from "react-toastify";
import DispatchManifestIcon from "../../Icons/DispatchManifestIcon";
interface PropsType {
  icon?: JSX.Element;
  data: any;
}
const DeliveryPartnerMenu = ({ icon, data }: PropsType) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const { id } = useParams();
  const [searchParams, setSearchParms] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["assign-delivery"],
  });

  const handleAssignDelivery = async (partnerId: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length && !id) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = APIS.ASSIGN_DELIVERY;
    const formData = {
      order_ids: selectedOrder ?? [id],
      delivery_partner: partnerId,
      client_type: "logistic",
    };
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
    } catch (err) {
      console.error(err);
    }
  };
  // const { data: assginedData } = useGetHook({
  //   queryKey: [`assign-delivery-${id}`],
  //   url: `${APIS.DELIVERY_PARTNER}is-delivery-exists/`,
  //   params: {
  //     order: id,
  //   },
  // });

  const calculatePopupPosition = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownHeight = 200;
      const dropdownWidth = 200;
      const { innerWidth, innerHeight } = window;

      let top = rect.bottom + window.scrollY;
      let left = rect.left + window.scrollX;

      if (top + dropdownHeight > innerHeight + window.scrollY) {
        top = rect.top + window.scrollY - dropdownHeight;
      }

      if (left + dropdownWidth > innerWidth + window.scrollX) {
        left = innerWidth - dropdownWidth - 16;
      }

      setPopupPosition({ top, left });
    }
  };

  useEffect(() => {
    if (isOpen) {
      const updatePosition = () => calculatePopupPosition();

      window.addEventListener("scroll", updatePosition, true);
      window.addEventListener("resize", updatePosition);

      return () => {
        window.removeEventListener("scroll", updatePosition, true);
        window.removeEventListener("resize", updatePosition);
      };
    }
  }, [isOpen]);

  return (
    <Menu as="div" className={tw`relative inline-block text-left `}>
      {({ open }) => {
        if (open !== isOpen) {
          setIsOpen(open);
        }
        return (
          <>
            <Menu.Button
              disabled={isPostLoading || false}
              ref={buttonRef}
              onClick={calculatePopupPosition}
              className={tw`flex text-primary gap-x-1 w-full items-center pl-2 justify-center rounded-md text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <DispatchManifestIcon color={" var(--primary)"} />
              Deliver via
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                className={tw`fixed origin-top mt-2 w-fit z-30  divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
                style={{ top: popupPosition.top, left: popupPosition.left }}
              >
                <>
                  {Array.isArray(data) &&
                    data?.length > 0 &&
                    data?.map((item) => (
                      <div className="px-1 py-1 " key={item?.id}>
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              onClick={() => handleAssignDelivery(item?.id)}
                              disabled={isPostLoading || false}
                              className={tw`${
                                active
                                  ? tw`bg-primary text-white`
                                  : tw`text-gray-900`
                              } group whitespace-nowrap flex w-full items-center rounded-md px-3 py-2 text-sm `}
                            >
                              {item?.name}
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    ))}
                </>
              </Menu.Items>
            </Transition>
          </>
        );
      }}
    </Menu>
  );
};

export default DeliveryPartnerMenu;
